var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.77 8.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #003189;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.36,8.8L.29,1.71c-.39-.39-.39-1.02,0-1.41.39-.39,1.02-.39,1.41,0l5.66,5.68L13.07.29c.39-.39,1.02-.39,1.42,0,.39.39.39,1.02,0,1.41l-7.12,7.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron1);
export default __webpack_public_path__ + "static/media/chevron-1.62fb4f84055fdd47f4ea9a3c78911267.svg";
export { ForwardRef as ReactComponent };